import axios from 'axios';

import router from '@/router';

import { Notification, Loading } from 'element-ui';

import CryptoJS from 'crypto-js';

import signMd5Utils from './signMd5Utils'

let loadingInstance;

function startLoading() {
  loadingInstance = Loading.service({
    lock: true,
    text: '加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
}

function endLoading() {
  if (loadingInstance) {
    loadingInstance.close();
  }
}

// 创建axios实例
const service = axios.create({
  baseURL: '/jeecg-boot', // api的base_url
  timeout: 60000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    startLoading();
    // 登录接口不需要token，可以通过url判断
    if (config.url.indexOf('/sys/randomImage') < 0 && config.url !== '/sys/login' ) {
      // 这里添加获取token的逻辑，例如从localStorage或vuex获取
      let token = localStorage.getItem('token');
      if (token) {
        config.headers['X-Access-Token'] = `${token}`;
      }
    }
    let sign = signMd5Utils.getSign(config.url, {});
    config.headers['X-Sign'] = sign;
    config.headers['X-TIMESTAMP'] = signMd5Utils.getTimestamp();
    return config;
  },
  error => {
    endLoading();
    // 请求错误处理
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    endLoading();
    // 对响应数据做处理，例如只返回data部分
    const requestHeaders = response.config.headers;
    const sign = requestHeaders['X-Sign'];
    const timestamp = requestHeaders['X-TIMESTAMP'];
    // 判断返回的是字符串还是json
    var data = response.data;
    if (typeof data === 'string') {
      let str = generate16DigitTimestamp(timestamp)
      let newStr = extractByTimestamp(str,sign)
      data = JSON.parse(decryptData(data,newStr));
      console.log('解密后的数据:', response.data);
    }
    return data;
  },
  error => {
    if (error.response) {
      endLoading();
      let data = error.response.data
      const token = localStorage.getItem('token');
      console.log("------异常响应------", token)
      console.log("------异常响应------", error.response.status)
      // const h = this.$createElement;
      switch (error.response.status) {
        case 403:
          Notification.error({
            title: '系统提示',
            message: '拒绝访问'
          })
          break
        case 500:
          console.log("------error.response------", error.response)
          Notification.error({
            title: '系统提示',
            message: '很抱歉，登录已过期，请重新登录'
          })
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          router.replace({path:'/',})
          // setTimeout(() => {
          //   location.reload()
          // }, 1000)
          break
        case 404:
          Notification.error({
            title: '系统提示',
            message: '很抱歉，资源未找到!'
          })
          break
        case 504:
          Notification.error({
            title: '系统提示',
            message: '网络超时'
          })
          break
        case 401:
          Notification.error({
            title: '系统提示',
            message: '很抱歉，登录已过期，请重新登录'
          })
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          router.replace({path:'/'})
          break
        default:
          Notification.error({
            title: '系统提示',
            message: data.message
          })
          break
      }
    } else if (error.message) {
      if (error.message.includes('timeout')) {
        Notification.error({
          title: '系统提示',
          message: '网络超时'
        })
      } else {
        Notification.error({
          title: '系统提示',
          message: error.message
        })
      }
    }
    // 响应错误处理
    return Promise.reject(error);
  }
);

function generate16DigitTimestamp(str) {
    // 获取当前毫秒级时间戳（13位数字）
    const timestamp = str + '';
    
    // 确保时间戳至少有3位（实际上时间戳远超过3位）
    if (timestamp.length < 3) {
        throw new Error("时间戳长度不足，无法生成16位时间戳");
    }
    
    // 截取时间戳的前3位
    const prefix = timestamp.substring(0, 3);
    
    // 计算需要补充的位数
    const needLength = 16 - timestamp.length;
    
    if (needLength <= 0) {
        // 如果时间戳长度超过或等于16位，取前16位
        return timestamp.substring(0, 16);
    } else {
        // 从prefix中截取需要的位数来补充
        const suffix = prefix.substring(0, needLength);
        // 拼接生成16位时间戳
        return timestamp + suffix;
    }
}

function extractByTimestamp(timestamp, sourceStr) {
    // 确保时间戳是字符串格式，方便遍历每个数字
    const timestampStr = timestamp.toString();
    let result = '';
    
    // 遍历时间戳的每个数字
    for (let i = 0; i < timestampStr.length; i++) {
        // 将字符转换为数字作为索引
        const index = parseInt(timestampStr[i], 10);
        
        // 确保索引在有效范围内
        if (index >= 0 && index < sourceStr.length) {
            // 提取对应位置的字符并拼接到结果中
            result += sourceStr[index];
        } else {
            // 索引超出范围时的处理，可以根据需要调整
            throw new Error(`索引 ${index} 超出源字符串长度范围`);
        }
    }
    
    return result;
}

function decryptData(encryptedData,str) {
  const key = CryptoJS.enc.Utf8.parse(str); // 密钥
  const iv = CryptoJS.enc.Utf8.parse('2B5d8G1j4M7p0S3V');  // 偏移量

  // AES-CBC 解密
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

export default service;